import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import Imagic from "../../../components/imagic/imagic";
import { Product } from "../../../models/home-rows";
import AppContext from "../../../services/app-context-services";
import { trackEvent } from "../../../services/ga-services";
import { ROUTES } from "../../../services/router-services";
import { lastNumberPart, _, _c } from "../../../services/text-services";
// @ts-ignore
import styles from "./single-product.component.module.scss";
interface FeatureItemProps {
  product: Product;
  isRelatedFile: boolean;
  relatedResponse?: (id: number) => void;
  gaTitle: string;
}


function AppSingleProduct({
  gaTitle = "",
  product,
  isRelatedFile,
  relatedResponse
}: FeatureItemProps) {
  // console.log(product);
  const router = useRouter();
  const {isIntlUser, setShowLoginPopup} = useContext(AppContext);
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!product?.id || isIntlUser) return;
    if (isRelatedFile && !!product.product_id) {
      setUrl(ROUTES.product(product, product.id));
    } else if (product?.id) {
      setUrl(ROUTES.product(product));
    }
  }, [isRelatedFile, product?.product_id, product?.id, product?.name_english]);

  const content = (
    <>
      <div className={_c(styles, "mouse-off")}>
        {product?.avatar?.hdpi && (
          <Imagic
            className={_c(styles, "avatar")}
            src={product.avatar.hdpi}
            alt="product.name"
            width="192"
            height="277"
            //loader={simpleLoader}
          />
        )}
      </div>
      <div className={_c(styles, "name")}>{_(product.name)}</div>
    </>
  );

  return (
    <div
      className={_c(styles, "product")}
      onClick={e => {
        const isTargetProduct = !lastNumberPart(router?.query?.slug?.[2]);
        const gaCategory = !isRelatedFile ? "Home Item" : (router?.query?.slug?.[0] === "game")  ? "Related Game" : "Related Product";
        trackEvent(gaCategory, gaTitle , product?.name);
        if (isRelatedFile && isTargetProduct) relatedResponse(product.id);
        if (isIntlUser) {
          e.preventDefault();
          e.stopPropagation();
          setShowLoginPopup(true);
        }
      }}
    >
      {isIntlUser ? (
        <div>{content}</div>
      ) : (
        <Link href={url} prefetch={false}>
          <a>{content}</a>
        </Link>
      )}
    </div>
  );
}

export default AppSingleProduct;
